module.exports = __webpack_public_path__ + "img/hr-train-stop-bottom.89461831.png";